import axios from "axios";

// ✅ Sirf .env se URL lega
const API_BASE_URL = process.env.REACT_APP_API_URL;
const BASE_URL = `${API_BASE_URL}Medicine`;

export const fetchMedicineByBrand = async (brandId) => {
  try {
    const res = await axios.get(
      `${BASE_URL}/GetMedicineByBrand?Id=${brandId}`
    );

    const data = Array.isArray(res.data) ? res.data : [];

    return data.map((item) => ({
      ...item,
      image: "https://placehold.co/200x200?text=Medicine",
    }));
  } catch (error) {
    console.error("Brand medicine error:", error);
    return [];
  }
};